import { graphql } from "@/lib/gql/__generated__";

export const RoomI18nArticleUpdate_DesignPage_Mutation = graphql(`
	mutation RoomI18nArticleUpdate_DesignPage($input: RoomI18nArticleInput!) {
		roomI18nArticleUpdate(input: $input) {
			userErrors
			roomI18n {
				id
				lang
				hotelID
				roomID
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				articleTitle
				name
				catchCopy
				description
				address {
					nationality
					postalCode
					state
					pref
					city
					town
					other
				}
			}
		}
	}
`);
